import SingleBar from './charts/bar/SingleBar'
import MultipleBar from './charts/bar/MultipleBar'

const Components = {
	SingleBar,
	MultipleBar
}

export default Components
